
(function($) {
    "use strict";

    $(window).ready(init);

    // Constants
    /**
     * Init
     */
    function init() {
        if(jQuery( ".CoupApres").length > 0){
            jQuery( ".CoupApres .layout__region--first" ).each(function(  ) {
                if (jQuery( this ).children().length === 0) {
                   var  data = jQuery( this ).parent().data("quickedit-entity-id");
                   var nodeLien =  jQuery(".layout--twocol[data-quickedit-entity-id='"+data+"'] .layout__region--second .field--name-field-titre a").attr('href');
                    jQuery( this ).append('<div class="field field--name-field-image-a-la-une-media field--type-entity-reference field--label-hidden field__item""> ' +
                        '<a href="'+nodeLien+'">' +
                        ' <img src="/themes/igs/public/images/coupapres.jpg" alt="Coup d apres" height="125" width="370">' +
                        '</a>' +
                        ' </div>');
                }
            });
        }


        if(jQuery( ".field--name-field-remonte-post-home").length > 0){
            jQuery( ".field--name-field-remonte-post-home .node__content" ).each(function(  ) {
                if (jQuery( this ).children()[0].className !== 'field-group-link') {
                    // var  data = jQuery( this ).parent().data("quickedit-entity-id");
                    // var nodeLien =  jQuery(".layout--twocol[data-quickedit-entity-id='"+data+"'] .layout__region--second .field--name-field-titre a").attr('href');
                    jQuery( this ).prepend('<a href="'+jQuery( this ).find(".savoir_plus").attr("href")+'" class="field-group-link" hreflang="fr">' +
                        '<div data-quickedit-field-id="node/65/field_image_a_la_une_media/fr/post_home" class="field field--name-field-image-a-la-une-media field--type-entity-reference field--label-hidden field__item quickedit-field"> ' +
                        '<img src="/themes/igs/public/images/coupapres.jpg" alt="Vignette" title="posthome" width="100%"> ' +
                        '</div>' +
                        '</a>');
                }
            });
        }

    }
})(jQuery);

